export const genTimestamp = (millisecond = Date.now()) => {
    const date = new Date(millisecond);
    const ymd = [
        date.getFullYear(),
        (date.getMonth() + 1).toString().padStart(2, '0'),
        date.getDate().toString().padStart(2, '0'),
    ].join('-');
    const hms = [
        date.getHours(),
        date.getMinutes().toString().padStart(2, '0'),
        date.getSeconds().toString().padStart(2, '0'),
    ].join(':');
    return ymd + ' ' + hms;
};
//# sourceMappingURL=time.js.map